import {Sidebar} from "primereact/sidebar";
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import {useState} from "react";
import {Leaderboard} from "../data/leaderboard";
import {Dropdown} from "primereact/dropdown";
import Sorting from "../data/sorting";

interface LeaderboardEditSidebarProps {
    visible: boolean;
    onHide: () => void;
    leaderboard: Leaderboard;
    onSave: (updatedLeaderboard: Leaderboard) => void;
}

function LeaderboardEditSidebar(
    {
        visible,
        onHide,
        leaderboard,
        onSave,
    }: LeaderboardEditSidebarProps) {
    const [editedLeaderboard, setEditedLeaderboard] = useState<Leaderboard>({...leaderboard});

    const handleSave = () => {
        onSave(editedLeaderboard);
    };

    return (
        <Sidebar
            visible={visible}
            onHide={onHide}
            header="Edit Leaderboard"
            position="right"
            style={{width: "30rem"}}
        >
            <div className="p-fluid">
                <div className="field">
                    <label htmlFor="name">Name</label>
                    <InputText
                        id="name"
                        value={editedLeaderboard.name}
                        maxLength={128}
                        onChange={(e) => setEditedLeaderboard({...editedLeaderboard, name: e.target.value,})
                        }
                    />
                </div>
                <div className="field">
                    <label htmlFor="sorting">Sorting</label>
                    <Dropdown
                        id="sorting"
                        value={editedLeaderboard.sorting}
                        onChange={(e) => setEditedLeaderboard({...editedLeaderboard, sorting: e.target.value})}
                        options={[Sorting.Descending, Sorting.Ascending]}
                        optionLabel="name"
                        className="w-full"/>
                </div>
                <Button
                    label="Speichern"
                    icon="pi pi-check"
                    onClick={handleSave}
                    className="mt-3"
                />
            </div>
        </Sidebar>
    );
}

export default LeaderboardEditSidebar;
